var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHyvanElamanAsuinymparisto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142 142",
    style: {
      enableBackground: "new 0 0 142 142"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E64F2A;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 71,
    cy: 71,
    r: 71
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.3,56.7L90,48V32.5h13.3V56.7z M94.5,45.6l4.4,2.8V37h-4.4V45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.3,111.9H37.8V51.5l1-0.7c8.1-5.4,16.3-10.7,24.4-16.1l7.1-4.7l1.8,1l21.3,14c2.1,1.4,4.2,2.8,6.3,4.1 l3.6,2.3V111.9z M42.3,107.4h56.6V53.9l-1.5-1c-2.1-1.4-4.2-2.8-6.3-4.1L70.5,35.3l-4.8,3.1c-7.8,5.1-15.6,10.3-23.4,15.4V107.4 z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "110.6,61.5 91,48.7 70.9,35 31.4,60.8 28.9,57.1 71,29.6 93.5,45 113.1,57.7  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "81.8,109.7 77.4,109.7 77.4,78.6 64.6,78.6 64.6,109.7 60.2,109.7 60.2,74.1 81.8,74.1  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyvanElamanAsuinymparisto);
export default __webpack_public_path__ + "static/media/hyvan-elaman-asuinymparisto.a95f339f1726c03cf35cdb42ea251677.svg";
export { ForwardRef as ReactComponent };